import React from 'react'
import { FacetName, FilterName } from '../../__generated__/fed-graphql-types'
import { withFilterContext } from '../hocs/filter.context.hoc'
import { withFacetContext } from '../hocs/facet.context.hoc'
import { SimpleCheckbox } from '../../components/search-filters-simple-checkbox/simple-checkbox'
import { IconNorthernIreland } from '@at/design-system-icons'

export const NIOnly = withFacetContext(
    FacetName.ni_only,
    withFilterContext(FilterName.ni_only, SimpleCheckbox, {
        title: 'N.Ireland adverts only',
        hideOnDisabled: false,
        icon: <IconNorthernIreland title={'Northern Ireland Icon'} customSize={{ height: 18, width: 18 }} />,
    })
)
